export type Period = "daily" | "weekly" | "monthly";

export const PERIOD_LABELS: Record<Period, string> = {
  daily: "Günlük",
  weekly: "Haftalık",
  monthly: "Aylık",
};

const pad = (n: number) => String(n).padStart(2, "0");

// Yerel saate göre YYYY-MM-DD (toISOString UTC'ye çevirdiği için kullanılmaz)
export const toISO = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const fromISO = (s: string) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y!, m! - 1, d!);
};

export const todayISO = () => toISO(new Date());

const addDays = (d: Date, n: number) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

const fmtDay = new Intl.DateTimeFormat("tr-TR", { day: "numeric", month: "long", year: "numeric" });
const fmtDayShort = new Intl.DateTimeFormat("tr-TR", { day: "numeric", month: "long" });
const fmtMonth = new Intl.DateTimeFormat("tr-TR", { month: "long", year: "numeric" });
const fmtWeekday = new Intl.DateTimeFormat("tr-TR", { weekday: "long" });

export const formatDayLong = (iso: string) => {
  const d = fromISO(iso);
  return `${fmtDay.format(d)}, ${fmtWeekday.format(d)}`;
};

export type Range = { from: string; to: string; label: string };

// Seçili tarihi içeren gün / hafta (Pazartesi–Pazar) / ay aralığı
export function rangeFor(period: Period, anchorISO: string): Range {
  const a = fromISO(anchorISO);
  if (period === "daily") {
    return { from: anchorISO, to: anchorISO, label: formatDayLong(anchorISO) };
  }
  if (period === "weekly") {
    const start = addDays(a, -((a.getDay() + 6) % 7));
    const end = addDays(start, 6);
    const sameYear = start.getFullYear() === end.getFullYear();
    const label = `${(sameYear ? fmtDayShort : fmtDay).format(start)} – ${fmtDay.format(end)}`;
    return { from: toISO(start), to: toISO(end), label };
  }
  const start = new Date(a.getFullYear(), a.getMonth(), 1);
  const end = new Date(a.getFullYear(), a.getMonth() + 1, 0);
  const label = fmtMonth.format(start);
  return { from: toISO(start), to: toISO(end), label: label[0]!.toLocaleUpperCase("tr-TR") + label.slice(1) };
}

// Seçili dönemi bir önceki/sonraki döneme kaydırır
export function shiftAnchor(period: Period, anchorISO: string, dir: -1 | 1): string {
  const a = fromISO(anchorISO);
  if (period === "daily") return toISO(addDays(a, dir));
  if (period === "weekly") return toISO(addDays(a, 7 * dir));
  return toISO(new Date(a.getFullYear(), a.getMonth() + dir, 1));
}
